/**
 * El color del botón de un correo de AR, y la tinta que se lee encima.
 *
 * ── Por qué está compartido ─────────────────────────────────────────────────
 * Lo usan **dos sitios que tienen que decir lo mismo**: el backend, que monta el
 * botón que le llega al deudor, y el editor de plantillas, que lo pinta mientras
 * alguien escribe. Mientras cada uno tuvo su propio color, el editor enseñaba un
 * azul fijo y el correo salía con el de la empresa: lo que veías no era lo que
 * se mandaba, y nadie podía saberlo sin mandarse un correo a sí mismo.
 *
 * ── La tinta no es un detalle estético ──────────────────────────────────────
 * El fondo del botón es el color que elige la empresa. Si elige uno claro —un
 * amarillo corporativo, por ejemplo— el texto blanco deja el botón ilegible: se
 * ve un rectángulo de color sin palabras. Y no daría ningún error; lo
 * descubriría el deudor al no encontrar dónde pagar. Luminancia relativa de la
 * W3C, con el umbral habitual.
 */

/** El azul de ClaimUp. Es el que sale cuando la empresa no ha elegido ninguno. */
const COLOR_BOTON_POR_DEFECTO = '#2a78d6';

/**
 * Un hex de 6 dígitos o el de por defecto.
 *
 * Esto acaba dentro de un atributo `style` del correo, así que lo que no sea
 * exactamente un hex **no pasa**: no se trata de ser estricto por gusto, es que
 * un valor con comillas o paréntesis ahí es marcado inyectado.
 */
function colorSeguro(valor) {
  return /^#[0-9a-fA-F]{6}$/.test(String(valor || '')) ? String(valor) : COLOR_BOTON_POR_DEFECTO;
}

/** Negro o blanco, según lo que se lea sobre ese fondo. */
function tintaSobre(fondoHex) {
  const hex = colorSeguro(fondoHex);

  const canal = i => {
    const v = parseInt(hex.slice(1 + i * 2, 3 + i * 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  };

  const luminancia = 0.2126 * canal(0) + 0.7152 * canal(1) + 0.0722 * canal(2);
  return luminancia > 0.45 ? '#111111' : '#ffffff';
}

module.exports = { COLOR_BOTON_POR_DEFECTO, colorSeguro, tintaSobre };
